import React from "react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface GCPListPageProps extends NSARouterMakerResult, CredentialProps { }

export default class GCPListPage extends React.Component<GCPListPageProps>
{
	override render()
	{
		return (
			<CredentialLayout
				{...this.props}
				action={{
					description: "This section lists all the Google Cloud Platform (GCP) credentials saved in your workspace, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
				}}
				pages={{
					entity: CredentialEntities.gcp(this.props),
					list: {
						ui: {}
					}
				}}
			>
				<></>
			</CredentialLayout >
		);
	}
}